import { Injectable, EventEmitter } from '@angular/core';
import { MainService } from './main.service';
declare var $: any;
declare var $a: any;
@Injectable()
export class SignalrService {
  private connection: any;
  private url: string;
  private proxy: any;
  private pos_connection: any;
  private pos_url: string;
  private pos_proxy: any;
  public CustomerDispaly: EventEmitter<any>;
  public GetDataFromVoip: EventEmitter<any>;
  public GetDataFromPrint: EventEmitter<any>;
  public GetDataFromKDS: EventEmitter<any>;
  public GetDataFromCounter: EventEmitter<any>;
  public GetFromMultiplePrint: EventEmitter<any>;
  private tryingToReconnect = false;
  private allowSocket = true;

  constructor(private ms: MainService) {
    this.allowSocket = this.ms.CommonSetting.SocketAllow;
    this.url = this.ms.CommonSetting.SocketUrl + '/signalr'
    // this.CustomerDispaly = new EventEmitter<any>();
    // this.GetDataFromVoip = new EventEmitter<any>();
    // this.GetDataFromPrint = new EventEmitter<any>();
    // this.GetDataFromKDS = new EventEmitter<any>();
    // this.GetDataFromCounter = new EventEmitter<any>();
    this.GetFromMultiplePrint = new EventEmitter<any>();

    this.Connecting();
  }

  onOnline(data) {

  }
  private Connecting() {
    if (!this.allowSocket) {
      return;
    }
    this.connection = $.connection.hub;
    this.proxy = $.connection.customerDisplay;
    this.connection.url = this.url;
    this.proxy.on('GetFromMultiplePrint', data => {
      this.onRecived(data);
    });
    // this.proxy.on("GetDataFromVoip", data => {
    //   this.onRecivedFromVoip(data);
    // });
    // this.proxy.on("GetDataFromKDS", data => {
    //   this.onRecivedFromKDS(data);
    // });
    // this.proxy.on("GetDataFromCounter", data => {
    //   this.onRecivedFromCounter(data);
    // });
    this.connection
      .start({ jsonp: true })
      .done((data: any) => {
        // this.SendToVoip({ UID: this.ms.Settings.UID, LocationId: this.ms.Settings.LocationId, Message: "Connected" })
      })
      .fail((err: any) => {
        console.log('Could not Connect :' + err);
      });
    this.connection.reconnecting(() => {
      // this.SendToVoip({ UID: this.ms.Settings.UID, LocationId: this.ms.Settings.LocationId, Message: "disconnected" })
      this.tryingToReconnect = true;
    });
    this.connection.reconnected(() => {
      this.tryingToReconnect = false;
    });
    this.connection.error((error) => {
      this.connection();
    });
    this.connection.disconnected(() => {
      if (this.tryingToReconnect) {
        setTimeout(() => {
          this.connection();
        }, 5000);

      }
    });

  }
  onRecived(data) {
    // this.GetFromMultiplePrint.emit(data);
  }
  // onRecivedFromVoip(data) {
  //   this.GetDataFromVoip.emit(data);
  // }
  // onRecivedFromKDS(data) {
  //   this.GetDataFromKDS.emit(data);
  // }
  // onRecivedFromCounter(data) {
  //   this.GetDataFromCounter.emit(data);
  // }
  // public sendToDisplay(data) {
  //   if (!this.allowSocket) {
  //     return;
  //   }
  //   this.proxy.server.sendToDisplay(data);
  // }
  // public SendToVoip(data) {
  //   if (!this.allowSocket) {
  //     return;
  //   }
  //   this.proxy.server.sendToVoip(data);
  // }
  // public sendToPrint(data) {
  //   if (!this.allowSocket) {
  //     return;
  //   }
  //   this.proxy.server.sendToPrint(data);
  // }
  // public sendToPrintText(data) {
  //   if (!this.allowSocket) {
  //     return;
  //   }
  //   this.proxy.server.sendToPrintText(data);
  // }
  // public sendToCounter(data) {
  //   if (!this.allowSocket) {
  //     return;
  //   }
  //   this.proxy.server.sendToCounter(data);
  // }
  // public sendToKDS() {
  //   if (!this.allowSocket) {
  //     return;
  //   }
  //   // var data = { DayOpenId: this.ms.Settings.DayOpenId, LocationId: this.ms.Settings.LocationId, Message: "" }
  //   // this.proxy.server.sendToKDS(data);
  // }
  public sendToMultiplePrint(data) {
    if (!this.allowSocket) {
      return;
    }
    this.proxy.server.sendToMultiplePrint(data);
  }
}
